import CarImage from '../Components/Images/mobile version/image 9.png'; 
export const carRecommendations = [
    {
      image: CarImage,
      model: 'Tata Tiago',
      year: '2024',
      price: '₹ 8.50 Lakhs',
      variant: 'Limited (O) 1.4 Petrol AT',
      emiStart: '₹25000'
    },
    {
        image: CarImage,
        model: 'Tata Tiago',
        year: '2024',
        price: '₹ 8.50 Lakhs',
        variant: 'Limited (O) 1.4 Petrol AT',
        emiStart: '₹25000'
      },
      {
        image: CarImage,
        model: 'Tata Tiago',
        year: '2024',
        price: '₹ 8.50 Lakhs',
        variant: 'Limited (O) 1.4 Petrol AT',
        emiStart: '₹25000'
      },
      {
        image: CarImage,
        model: 'Tata Tiago',
        year: '2024',
        price: '₹ 8.50 Lakhs',
        variant: 'Limited (O) 1.4 Petrol AT',
        emiStart: '₹25000'
      }
    // Add more car recommendations here
  ];